import Endorsement_Linear_Black from './assets/JH/Endorsement_Linear/black.svg.js';
import Endorsement_Linear_Color from './assets/JH/Endorsement_Linear/color.svg.js';
import Endorsement_Linear_Reverse from './assets/JH/Endorsement_Linear/reverse.svg.js';
import Endorsement_Linear_White from './assets/JH/Endorsement_Linear/white.svg.js';
import Endorsement_Stacked_Black from './assets/JH/Endorsement_Stacked/black.svg.js';
import Endorsement_Stacked_Color from './assets/JH/Endorsement_Stacked/color.svg.js';
import Endorsement_Stacked_Reverse from './assets/JH/Endorsement_Stacked/reverse.svg.js';
import Endorsement_Stacked_White from './assets/JH/Endorsement_Stacked/white.svg.js';
import Linear_Black from './assets/JH/IM_Linear/black.svg.js';
import Linear_Color from './assets/JH/IM_Linear/color.svg.js';
import Linear_White from './assets/JH/IM_Linear/white.svg.js';
import Stacked_Black from './assets/JH/IM_Stacked/black.svg.js';
import Stacked_Color from './assets/JH/IM_Stacked/color.svg.js';
import Stacked_White from './assets/JH/IM_Stacked/white.svg.js';
import Default_Black from './assets/JH/JohnHancock/black.svg.js';
import Default_Color from './assets/JH/JohnHancock/color.svg.js';
import Default_White from './assets/JH/JohnHancock/white.svg.js';

const JhInvestmentManagementLinear = {
  BLACK: Linear_Black,
  COLOR: Linear_Color,
  WHITE: Linear_White
};
const JhInvestmentManagementStacked = {
  BLACK: Stacked_Black,
  COLOR: Stacked_Color,
  WHITE: Stacked_White
};
const EndorsementLinear = {
  BLACK: Endorsement_Linear_Black,
  COLOR: Endorsement_Linear_Color,
  REVERSE: Endorsement_Linear_Reverse,
  WHITE: Endorsement_Linear_White
};
const EndorsementStacked = {
  BLACK: Endorsement_Stacked_Black,
  COLOR: Endorsement_Stacked_Color,
  REVERSE: Endorsement_Stacked_Reverse,
  WHITE: Endorsement_Stacked_White
};
var johnhancock = {
  BLACK: Default_Black,
  COLOR: Default_Color,
  WHITE: Default_White
};

export { EndorsementLinear, EndorsementStacked, JhInvestmentManagementLinear, JhInvestmentManagementStacked, johnhancock as default };
